import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
import { CTA_LABEL, site } from '../data/site';
const includedItems = ['5 Elementary volumes', '5 Secondary volumes', '5 exclusive bonuses', 'Instant digital delivery', 'Lifetime access', 'One-time payment'];
export function PricingSection() {
  return <section id="offer" className="scroll-mt-16 bg-brand-alt px-4 py-16 md:py-24" data-id="element-141" data-mp="1nasoax5dm2im">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-142" data-mp="1s9n6pxzflp27">
        <p className="mb-3 text-[11px] font-extrabold tracking-[0.18em] text-brand-teal" data-id="element-143" data-mp="1s8c6u993x1gd">SPECIAL LAUNCH OFFER</p>
        <h2 className="mb-10 text-3xl font-black text-brand-blue md:text-[2.5rem]" data-id="element-144" data-mp="1x9hwfy7h08lo">
          Get the Complete Physical Education Ready System
        </h2>
        <div className="relative mx-auto max-w-xl rounded-[2rem] border border-brand-orange bg-brand-alt p-7 pt-10 shadow-[0_18px_50px_rgba(18,58,99,0.10)] md:p-11 md:pt-12" data-id="element-145" data-mp="2vgzxjze7xor">
          <div className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-brand-orange px-5 py-2 text-[10px] font-extrabold tracking-[0.14em] text-white" data-id="element-146" data-mp="1mgoelaxrp9kc">
            PE READY — COMPLETE SYSTEM
          </div>
          <ul className="space-y-3 text-left" data-id="element-147" data-mp="1crelbrr6tkun">
            {includedItems.map(item => <li key={item} className="flex items-center gap-3 border-b border-brand-dark pb-3 text-sm" data-id="element-148" data-mp="17t39xcl8v2ab">
                <CheckIcon className="h-4 w-4 shrink-0 text-brand-teal" aria-hidden="true" data-id="element-149" data-mp="25f0q33c5ivj3" />
                <span className="font-semibold text-brand-text" data-id="element-150" data-mp="20hqzvlgxufu7">{item}</span>
              </li>)}
          </ul>
          <div className="my-8 border-y border-brand-dark py-7" data-id="element-151" data-mp="1vjftxltrkph9">
            <p className="text-xs font-semibold text-brand-gray" data-id="element-152" data-mp="1req002io1kyz">
              Regular price:{' '}
              <span className="font-bold text-brand-gray line-through" data-id="element-153" data-mp="k2z9fe3crinj">{site.regularPrice}</span>
              <span className="ml-2 rounded-full bg-brand-orange/12 px-2 py-1 text-[10px] font-extrabold tracking-[0.1em] text-brand-orange" data-id="element-154" data-mp="fzjhuw6548hp">
                {site.discount}% OFF
              </span>
            </p>
            <p className="mt-4 text-[11px] font-extrabold tracking-[0.16em] text-brand-teal" data-id="element-155" data-mp="mgck47fcm6zg">TODAY</p>
            <p className="mt-1 font-serif text-5xl font-black tracking-tight text-brand-blue md:text-6xl" data-id="element-156" data-mp="7j2dbbdnhpa2">
              {site.currentPrice}
            </p>
            <p className="mt-3 text-[10px] font-semibold tracking-wide text-brand-gray/70" data-id="element-157" data-mp="3uw4l6jxac4iu">
              Price, discount, and currency are editable placeholders — set final values before publishing.
            </p>
          </div>
          <CTAButton href={site.checkoutUrl} className="w-full py-4 text-base md:text-lg" data-id="element-158" data-mp="3kztatzh99or1">
            {CTA_LABEL}
          </CTAButton>
          <p className="mt-5 text-xs font-semibold text-brand-gray" data-id="element-159" data-mp="3pv8gw590ugcw">
            Secure checkout • Instant digital access • No subscription
          </p>
        </div>
      </Reveal>
    </section>;
}